<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/09-JS-testimonials.svg"
                class="img-fluid"
                alt="Learn from other students’ experiences"
                srcset=""
              >
            </h1>
          </div>
          <div class="col-md-5 p-5">
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="container">
        <video
          src="@/assets/video/centennial college - toolkit testimonials - video 2.mp4"
          controls
          controlslist="nodownload"
          playsinline
          poster="@/assets/img/_poster/centennial - testimonial video - poster 2.jpg"
          class="content-block__img mb-0 img-fluid mt-3"
        >
          <!-- Language, format and path to closed caption file-->
          <track
            label="English"
            kind="subtitles"
            srclang="en"
            :src="`${publicPath}cc/CC_V2_Tell_us_about_your_on_campus_job_toolkit_testimonials.vtt`"
            default
          />
        </video>
        <div class="accordion">
          <accordion
            headerText="Transcript"
            accordionID="collapse01"
          >
            <p><strong>Geina Khadaroo</strong></p>
            <p>Peer Tutor/Student Advocate, Learning Centre</p>
            <p>I'm Geina Khadaroo, a graduate of the Business Administration-Accounting program. </p>
            <p>As a student, I held two part-time jobs on campus. I serve as a peer tutor with the Learning Centre and a student advocate with Centennial College Student Association. As a peer tutor, I supported students with their coursework through tailored one-on-one sessions both in-person and virtually. As an advocate, I leverage the College policies, procedures and other resources to support students with their academic and non-academic concerns. </p>

            <p><strong>Jenna Crawford</strong></p>
            <p>Senior Campus Rep, Colts</p>
            <p><strong>Quote: “My key job duties include setup and takedown of all sports”</strong></p>
            <p>My key job duties here are overlooking my staff, which are the intramural campus rec staff and doing setup and takedown of all the sports every day, making the schedule for the intramurals, making sure all the equipment is available for use for all the students, and also just office duties with my boss, Ben.</p>

            <p><strong>Madonna Villena</strong></p>
            <p>Peer Tutor, Learning Centre</p>
            <p><strong>Quote: “I facilitate learning by providing assistance and guidance”</strong></p>
            <p>My name is Madonna Villena from the Business School and I am taking of International Business Management program at Progress Campus. I currently work as a peer tutor under the supervision of the Learning Centre of Centennial College. As a peer tutor, I facilitate learning of fellow students by providing them assistance and guidance in understanding specific elements of the course content, as well as by clarifying certain parts of the modules that they find confusing. </p>

            <p><strong>Sania Siddiqui</strong></p>
            <p>Vice President, Enactus</p>
            <p><strong>Quote: “I hold two key roles in a business-focused program”</strong></p>
            <p>My name is Sania. I'm a third-year student in the Nutrition and Food Service Management program, and today I'm here to talk about my on-campus job. So on campus, starting with my first semester, which was in September 2020, I was a part of an organization at Centennial called Enactus Centennial, which basically is an innovative, entrepreneurship, business-focused program here in collaboration with the Business School at Centennial College. And that is what I did up until now. Currently, I hold the position of vice president along with vice president, H.R. I sort of have like a double role. </p>

            <p><strong>Maisha Tariq</strong></p>
            <p>Marketing assistant, Career Services</p>
            <p><strong>Quote: “I help Centennial students and alumni develop their careers”</strong></p>
            <p>My name is Maisha and I'm studying Business Administration – Marketing. I'm currently working as a digital marketing intern for the Career Services and Co-op Education at Centennial College. I'm also working as a peer career coach for the Career Services, where I help Centennial students and alumni with resume and cover letter formatting, tips on job searching and networking. </p>
          </accordion>
        </div>
      </div>
    </content-block>

    <content-block class="px-sm-3">
      <div
        class="audio-player"
        ref="parentDiv"
      >
        <!-- <av-line
          v-if="doRender"
          :canv-width="cW"
          :line-width="1"
          line-color="#39B54A"
          ref-link="foo"
        ></av-line> -->
        <h3>Avanti Peusangan</h3>
        <p>Admin Assistant, Career Services</p>
        <vue-plyr>
          <audio
            controls
            crossorigin
            playsinline
            ref="foo"
          >
            <!-- src="@/assets/audio/personal/09.mp3" -->
            <source
              src="@/assets/audio/9- Avanti Peusangan.mp3"
              type="audio/mp3"
            />
          </audio>
        </vue-plyr>
      </div>
      <div class="accordion">
        <accordion
          headerText="Transcript"
          accordionID="collapse02"
        >
          <p>So I was working as a receptionist or administrative assistant as a co-op student at the Career Services Department. My key job duties consisted of reviewing and posting jobs from employers to Centennial's job board, HireCentennial, and advise students on job search methods as one of the peer career coaches, as well as responding to students and employers through email or phone calls.</p>
        </accordion>
      </div>

      <div>
        <div
          class="audio-player"
          ref="parentDiv"
        >
          <!-- <av-line
          v-if="doRender"
          :canv-width="cW"
          :line-width="1"
          line-color="#39B54A"
          ref-link="foo"
        ></av-line> -->
          <h3>Shernelle Charles</h3>
          <p>Retail Team Member, Bookstore</p>
          <vue-plyr>
            <audio
              controls
              crossorigin
              playsinline
              ref="foo"
            >
              <!-- src="@/assets/audio/personal/09.mp3" -->
              <source
                src="@/assets/audio/9-Shernelle_Charles_Testimonial.mp3"
                type="audio/mp3"
              />
            </audio>
          </vue-plyr>
        </div>
        <div class="accordion">
          <accordion
            headerText="Transcript"
            accordionID="collapse03"
          >
            <p>My on-campus job at Centennial College is for Follett, as a retail team member, the Department of Higher Education. My key job duties include handling day-to-day cash, debit, credit and myCard transactions, processing students' orders for supplies, books, uniforms, serving faculty and staff and updating inventory.</p>
          </accordion>
        </div>
      </div>

      <div>
        <div
          class="audio-player"
          ref="parentDiv"
        >
          <!-- <av-line
          v-if="doRender"
          :canv-width="cW"
          :line-width="1"
          line-color="#39B54A"
          ref-link="foo"
        ></av-line> -->
          <h3>Basirat Naphew</h3>
          <p>Member, Experience Centennial Student Leadership Team (ECSLT)</p>
          <vue-plyr>
            <audio
              controls
              crossorigin
              playsinline
              ref="foo"
            >
              <!-- src="@/assets/audio/personal/09.mp3" -->
              <source
                src="@/assets/audio/9-Basirat_Testimonial.mp3"
                type="audio/mp3"
              />
            </audio>
          </vue-plyr>
        </div>
        <div class="accordion">
          <accordion
            headerText="Transcript"
            accordionID="collapse04"
          >
            <p>My name is Basirat Naphew. I'm a Centennial graduate of the Social Service Worker program. I served as a member of the Experience Centennial Student Leadership Team, ECSLT, for the 2021 to 2022 academic year.</p>
          </accordion>
        </div>
      </div>
    </content-block>

    <content-block class="px-sm-3">
      <div class="row">
        <!-- <div class="col-md-6 order-md-2">
          <img src="@/assets/img/_content/9-career-chart.jpeg" alt="" class="content-block__img img-fluid mt-0">
        </div> -->
        <div class="col">
          <blockquote class="blockquote">
            <p><strong>I worked as a Math peer tutor in the Learning Centre.</strong></p>
            <p><strong>My key duties included providing academic support to all the students on various mathematical topics, identifying student's learning challenges and recommending new strategies to understand course material and to prepare for tests and exams, promoting other services offered by the Learning Centre through various events, class visits and peer tutoring which can be beneficial to students.</strong></p>
            <h3>Meshwat Upadhyay</h3>
            <p>Math peer tutor, Learning Centre</p>
          </blockquote>
        </div>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock,
    // SidebarMenu,
    Accordion
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      // GET CANVAS WIDTH DEMO
      cW: 0,
      doRender: false
    }
  },

  mounted () {
    // reset AvWaveform element width
    this.cW = this.$refs.parentDiv.offsetWidth - (16 * 2)
    // render it
    this.doRender = true
  }
}
</script>

<style>
</style>
